exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NC6qaILF7dGKjb{display:flex}", ""]);

// exports
exports.locals = {
	"sectionHeaderWrapper": "NC6qaILF7dGKjb"
};